<nav
  class="navbar"
  [class.mobile-menu-active]="isMobileMenuOpen"
>
  <a
    href="https://www.globalbattery.org"
    target="_blank"
    rel="noopener noreferrer"
    class="logo-container"
  >
    <img
      src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/gba_logo.png"
      alt="GBA Logo"
      class="logo"
      height="26px"
      width="77.27px"
    />
  </a>

  <lib-icon-button
    [icon]="isMobileMenuOpen ? 'x' : 'menu'"
    (click)="toggleMobileMenu()"
  ></lib-icon-button>

  <div
    class="mobile-menu-content"
    [class.show]="isMobileMenuOpen"
    [animate.enter]="'slide-in'"
    [animate.leave]="'slide-out'"
  >
    @if (isMobileMenuOpen && menuItems().length > 0) {
      <div class="mobile-menu-content-header">
        <a
          href="https://www.globalbattery.org"
          target="_blank"
          rel="noopener noreferrer"
          class="logo-container"
        >
          <img
            src="https://d1sips1sizw66e.cloudfront.net/gba/images/logos/gba_logo.png"
            alt="GBA Logo"
            class="logo"
            height="25px"
            width="74.3px"
          />
        </a>

        <lib-icon-button
          [icon]="isMobileMenuOpen ? 'x' : 'menu'"
          (click)="toggleMobileMenu()"
        ></lib-icon-button>
      </div>
      <ul class="mobile-menu-list">
        @for (item of menuItems(); track item.label; let i = $index) {
          @if (shouldShowItem(item)) {
            <li
              class="mobile-menu-item"
              [animate.enter]="'fade-in-right'"
            >
              <!-- Regular route navigation -->
              @if (item.route && !item.click && !item.dropdown) {
                <a
                  [routerLink]="item.route"
                  routerLinkActive="active"
                  class="mobile-menu-link"
                  (click)="toggleMobileMenu()"
                >
                  @if (item.icon) {
                    <i-feather
                      [name]="item.icon"
                      class="menu-icon"
                    ></i-feather>
                  }
                  <span>{{ item.label | translate }}</span>
                </a>
              }

              <!-- External url navigation -->
              @if (item.url && item.external) {
                <a
                  [href]="item.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="mobile-menu-link"
                >
                  @if (item.icon) {
                    <i-feather
                      [name]="item.icon"
                      class="menu-icon"
                    ></i-feather>
                  }
                  <span>{{ item.label | translate }}</span>
                </a>
              }

              <!-- Click action (no route) -->
              @if (item.click && !item.route && !item.dropdown) {
                <button
                  type="button"
                  class="mobile-menu-button"
                  (click)="item.click(); toggleMobileMenu()"
                >
                  @if (item.icon) {
                    <i-feather
                      [name]="item.icon"
                      class="menu-icon"
                    ></i-feather>
                  }
                  <span>{{ item.label | translate }}</span>
                </button>
              }

              <!-- Dropdown menu -->
              @if (item.dropdown && item.dropdownItems) {
                <div class="mobile-dropdown">
                  <button
                    type="button"
                    class="mobile-dropdown-toggle"
                    [class.active]="isDropdownOpen(i)"
                    (click)="toggleDropdown(i)"
                  >
                    @if (item.icon) {
                      <i-feather
                        [name]="item.icon"
                        class="menu-icon"
                      ></i-feather>
                    }
                    <span>{{ item.label | translate }}</span>
                    <i-feather
                      [name]="isDropdownOpen(i) ? 'chevron-up' : 'chevron-right'"
                      class="dropdown-chevron"
                    ></i-feather>
                  </button>

                  @if (isDropdownOpen(i)) {
                    <ul
                      class="mobile-dropdown-menu"
                      [animate.enter]="'fade-in-right'"
                      [animate.leave]="'fade-out'"
                    >
                      @for (dropdownItem of item.dropdownItems; track dropdownItem.label) {
                        <li>
                          <button
                            type="button"
                            class="mobile-dropdown-item"
                            (click)="dropdownItem?.click(); toggleMobileMenu()"
                          >
                            @if (dropdownItem.svgUrl) {
                              <img
                                class="flag-icon"
                                [src]="dropdownItem.svgUrl"
                                alt="flag"
                              />
                            }
                            {{ dropdownItem.label | translate }}
                          </button>
                        </li>
                      }
                    </ul>
                  }
                </div>
              }
            </li>
          }
        }
      </ul>
    }
  </div>
</nav>
